import React from 'react';
import HOne from "../h-one";
import { withRouter, Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import ServerApi from '../../services/server-api-service';
import StringProcessingService from '../../services/string-processing-service';
import ConfigurationService from '../../services/configuration-service';
import SeoService from '../../services/seo-service';
import parser from 'html-react-parser';
import UserForm from '../user-form';
import InnerArticleGrid from '../inner-article-grid';
import ReactPlayer from 'react-player';
import Modal from '../modal';
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
} from "react-share";

import './article-inner-page-style.css'
import { parse } from 'node-html-parser/dist/nodes/html';

class ArticleInnerPage extends React.Component {
    serverApi = new ServerApi();
    stringProcessingService = new StringProcessingService();
    configurationService = new ConfigurationService();
    seoService = new SeoService();
    constructor(props) {
        super(props);
        this.state = {
            debug: false,
            isVisibleMessage: false,
            isVisibleMessageScrollFlag: true,
            contactInfo: {
                userComment: "",
                userEmail: "",
                userFullName: "",
                userPhone: "",
                project: ''
            },
        };
        this.languagePrefix = this.configurationService.getCurrentLanguagePrefix();
    }

    getProjectArticles(id) {
        if (id) {
            this.serverApi.getArticlesForProject(id)
                .then((data) => {
                    let arr = data.data;
                    let articles = [];
                    arr.map((item) => {
                        if (item.id != this.props.match.params.id) {
                            articles.push(item);
                        }
                        return null;
                        // articles.push(item);
                    })
                    this.setState({
                        articles: articles
                    })
                })
                .catch((error) => {
                    console.log(`ERROR: fetch getNeighborhoodArticles ... -> Component: ArticleInnerPage ERROR:${error}`);
                })
        }
    }

    componentWillUnmount() {
        if (this.props.saveState) {
            this.props.saveState({
                articlesTranslations: null,
            })
        }

    }

    componentDidUpdate(prevProps) {
        let windowRelativeBottom = document.documentElement.getBoundingClientRect().bottom;
        if (windowRelativeBottom < ((document.documentElement.clientHeight + document.getElementsByClassName('Footer')[0].clientHeight) + (this.props.mobileVerison ? 1 : 0)) && prevProps.pageScroll < this.props.pageScroll && this.props.mobileVerison) {
            // добавим больше данных
            if (this.state.isVisibleMessage !== true && this.state.isVisibleMessageScrollFlag) {
                this.setState({
                    isVisibleMessage: true
                })
            }

        }

    }

    componentDidMount() {
        if (this.props.saveState) {
            this.props.saveState({
                pageIsLoaded: true
            })
        }
    }

    componentWillMount() {
        if (this.props.saveState) {
            this.props.saveState({
                currentPage: 'ArticleInnerPage',
                showSelectionToolBar: false,
                selectionMapFloating: false,
            })
        }

        if (this.props.match.params.id) {
            this.serverApi.getArticleInfo(this.props.match.params.id)
                .then((res) => {
                    let area = res.data.areas[0];
                    let project = res.data.projects[0];
                    let requestName = '';
                    let projectDepend = '';
                    if (this.props.saveState) {
                        this.props.saveState({
                            articlesTranslations: res.data.translations
                        })
                    }
                    if (res.data.language !== this.configurationService.getCurrentLanguagePrefix()) {
                        this.props.history.push('/articles')
                    }
                    if (project != null) {
                        requestName = project.name;
                        projectDepend = project.name;
                    } else if (area != null) {
                        requestName = area.name;
                        projectDepend = area.name;
                    }else{
                        requestName = this.props.dictionary.form_default_project ?? 'Miami';
                        projectDepend = this.props.dictionary.form_default_project ?? 'Miami';
                    }
                   
                    this.setState({
                        data: res.data,
                        contactInfo: {
                            ...this.state.contactInfo,
                            userComment: `${this.props.dictionary.send_me_more_details_about_project} ${requestName}`,
                            project: projectDepend
                        }
                    })
                    if (this.props.match.params.projectId) this.getProjectArticles(this.props.match.params.projectId);


                })
                .catch((error) => {
                    console.log(`ERROR: fetch getArticleInfo ... -> Component: ArticleInnerPage ERROR:${error}`);
                })
        }
    }

    renderInfo(data) {
        let parsedData = parser(data);
        // return (parsedData);
        if (Array.isArray(parsedData)) {
            return (
                parsedData.map((item, index) => {
                    if (item.type != null) {
                        switch (item.type) {
                            case 'p': {
                                if(item.props.children.type == 'a' && item.props.children.props.className == 'btn'){
                                    return (
                                        <p key={item.key} >
                                            <button className='Button ArticleButton'>
                                                {item.props.children}
                                            </button>
                                        </p>)
                                }

                                return (
                                    <p key={item.key} >
                                        {item.props.children}
                                    </p>)
                            }
                            case 'img': {
                                return (
                                    <img key={item.key} alt='Info' src={item.props.src} className={"ArtImg"}>
                                    </img>
                                )
                            }
                            case 'a':{
                                if(item.props.className == 'btn'){
                                    return (
                                            <button className='Button ArticleButton'>
                                                {item}
                                            </button>
                                        )
                                }
                            }
                            default: {
                                return item;
                            }
                        }
                    }
                    return item;
                })

            );
        } else return (parsedData);

    }

    closeModal = (isVisibleMessageScrollFlag = true) => {
        this.setState({
            isVisibleMessageScrollFlag: isVisibleMessageScrollFlag,
            isVisibleMessage: false
        })
    }

    handleInput = (event) => {
        this.setState({
            contactInfo: {
                ...this.state.contactInfo,
                [event.target.name]: event.target.value
            }
        })
    }

    clearForm = () => {
        this.setState({
            ...this.state,
            contactInfo: {
                userComment: "",
                userEmail: "",
                userFullName: "",
                userPhone: ""
            }
        })
    }

    renderMainImg() {
        let { data } = this.state;

        let project = data.projects[0];
        let area = data.areas[0];

        let { articleName } = this.props.match.params
        // let { dictionary, width, country, saveState } = this.props;
        let res = null;
        if (data.video != null) {
            res = (
                <>
                    <ReactPlayer
                        width={'100%'}
                        className='react-player fixed-bottom Video'
                        url={data.video}
                        controls={true}
                        config={{
                            youtube: {
                                playerVars: {
                                    modestbranding: 1,
                                    color: 'red'
                                }
                            },
                        }}
                    />
                    {data.captions.video && <div className={"ImageText"}>{data.captions.video}</div>}
                </>
            )
        }else 
        if (data.photo != null) {

            let parsedNameForUrl = this.stringProcessingService.StringFormatUrl(articleName);
           
            let link = `/${this.languagePrefix}/find-my-deal`;

            if((project != undefined && project.web_online != null)) link = `/${this.languagePrefix}/projects/${project.id}/${parsedNameForUrl}`;
            else if((area != undefined)){
                let parsedAreaName = this.stringProcessingService.StringFormatUrl(area.name);
                link = `/${this.languagePrefix}/neighborhood/${area.id}/${parsedAreaName}`;
            } 
            
            res = (
                <>
                    <a href={link}>
                        <img className={"ArtImg"} alt='Illustration' src={data.photo}></img>
                    </a>
                    {/* <div className={"ImageText"}>Illustration</div> */}
                    {data.captions.photo && <div className={"ImageText"}>{data.captions.photo}</div>}
                </>
            )
        }

        return res;

    }

    renderUserFormTitle() {
        let { data } = this.state;
        let { dictionary } = this.props;

        let area = data.areas[0];
        let project = data.projects[0];
        let title = '';
        let logo = <></>;
        let line = '';

        if (project != null) {
            if (project.logo != null) {
                line = 'none';
                logo = (
                    <Link to={`/${this.languagePrefix}/projects/${project.id}/${this.stringProcessingService.StringFormatUrl(project.name)}`}> <img className='FormLogo' src={`https://ngirealty.com/img/projects/${project.id}/${project.logo}`} alt='Logo'></img> </Link>
                )
            } else {
                title = `<br/>  ${project.name}`
            }
        } else if(area != null) {
            title = `<br/> ${area.name}`
        }
        else{
            title = `<br/> ${dictionary.form_default_project ?? 'Miami'}`
        }

        return (
            <div className={"SectionHdr"}>
                <HOne addclass={"lagresize"} line={line} title={`${dictionary.send_me_more_details_about_project} ${title}`} />
                {logo}
            </div>
        )
    }

    render() {

        const iconFb = require('../../elements/images/icon_fb.svg').default;
        const iconIn = require('../../elements/images/icon_in.svg').default;
        const iconTwi = require('../../elements/images/icon_twi.svg').default;
        const iconDate = require('../../elements/images/icon_date.svg').default;

        let { data, contactInfo, articles, isVisibleMessage } = this.state;
        let { dictionary, width, country, neighborhoods } = this.props;
        let { projectId, projectName, id, articleName } = this.props.match.params

        if (data != null) {
            let options = { year: 'numeric', month: 'long', day: 'numeric' };
            let locale = 'en-US';
            switch (this.configurationService.getCurrentLanguagePrefix()) {
                case 'pt': {
                    locale = "pt-PT";
                    break;
                }
                case 'es': {
                    locale = "es-ES";
                    break;
                }
                default: {
                    break;
                }

            }
            let date = new Date(data.date).toLocaleDateString(locale, options);

            let logo = '';
            let logoLink = '';
            let area = data.areas[0];
            let project = data.projects[0];
            let neighborhood;

            let filteredProjects = [];

            if (data.projects != null && Array.isArray(data.projects)) {
                data.projects.forEach(element => {
                    if (element.web_online != null) filteredProjects.push(element)
                });
            }

            let metaTitle = data.title;
            let description = data.body;
            if (data.meta.title != null) {
                metaTitle = data.meta.title;
            }
            if (data.meta.description != null) {
                description = data.meta.description
            }

            if (project != null && area != null && area.image_cover != null) {
                logo = `https://ngirealty.com/img/smart_luxe/areas/cover/${area.image_cover}`;
                logoLink = area.name;
            }

            if (project != null && project.cover_image != null) {

                logo = `https://ngirealty.com/img/projects/${project.id}/${project.cover_image}`;
                logoLink = project.name;
            } else if (area != null && area.image_cover != null) {
                logo = `https://ngirealty.com/img/smart_luxe/areas/cover/${area.image_cover}`;
                logoLink = area.name;
            }else{
                logo = require('../../elements/images/our_team_page.jpg');
                logoLink = `${dictionary.slogan_part_1.toUpperCase()} - ${dictionary.slogan_part_2.toUpperCase()}`
            }

            neighborhoods.forEach((item, index) => {
                if (project != null && item.id == project.area_id) {
                    neighborhood = item;
                } else if (area != null && area.id == item.id) {
                    neighborhood = item;
                }
            })

            let parsedNameForUrl = this.stringProcessingService.StringFormatUrl(articleName);

            return (
                <div className={"ArticleInnerPage"}>
                    <Helmet prioritizeSeoTags>
                        <title> {metaTitle} | Smart Luxe</title>
                        <meta name="description" content={description} />
                        {/* {articleName != null && id != null ? <link rel="canonical" href={`https://smartluxe.com/articles/${id}/${parsedNameForUrl}`}></link> : null} */}
                        {this.seoService.insertHrefLangTags(
                            {
                                path: `${this.configurationService.getCurrentLanguagePrefix()}/articles/:id/:name`,
                                params:{
                                    id:id,
                                    name:parsedNameForUrl
                                },
                                translations: data.translations,
                                currentLang:data.language
                            })
                        }
                      

                    </Helmet>
                    <div className="PageLogo">
                        <img id="PageLogoImg" alt="Logo" src={logo}></img>
                        <div id="PageLogoTitle">
                            {(project != undefined && project.web_online != null) ? <Link className="ProjectTitle" to={`/${this.languagePrefix}/projects/${project.id}/${parsedNameForUrl}`}>
                                <HOne line={width > 600 ? "lagre" : "none"} title={logoLink} className={'Title'} />
                            </Link> : <Link className="ProjectTitle" to={`/${this.languagePrefix}/find-my-deal`}> <HOne line={width > 600 ? "lagre" : "none"} title={logoLink} className={'Title'} /> </Link>}

                        </div>
                    </div>
                    <div className={"ArticleBody"}>
                        <h1>{data.title}</h1>
                        <div className={"date"}>
                            <img src={iconDate} alt="Date" />
                            {date}
                        </div>
                        {this.renderMainImg()}
                        {this.renderInfo(data.body)}

                        <div className={"Share"}>
                            {dictionary.share}: &nbsp;
                            <FacebookShareButton
                                url={document.location.href}
                                quote={data.title}
                            >
                                <img alt={"Facebook"} src={iconFb}></img>
                            </FacebookShareButton>
                            <LinkedinShareButton
                                url={document.location.href}
                                title={data.title}
                                summary={data.title}
                                source={data.title}
                            >
                                <img alt={"LinkedIn"} src={iconIn}></img>
                            </LinkedinShareButton>
                            <TwitterShareButton
                                url={document.location.href}
                                title={data.title}
                            >
                                <img alt={"Twitter"} src={iconTwi}></img>
                            </TwitterShareButton>
                           
                        </div>

                        <div className={"Separator"}></div>
                        {this.renderUserFormTitle()}

                        <UserForm
                            clearForm={this.clearForm}
                            topPartRow={true}
                            contactForm={contactInfo}
                            handleInput={this.handleInput}
                            width={width}
                            message={dictionary.thank_you_deal}
                            country={country}
                            thankModal={true}
                            secureInfo={true}
                            dictionary={dictionary}
                            className={'Form'}
                            CustomInputStyle={{ padding: '0 0 0 5px' }}
                            style={{ textAlign: 'center', display: 'block', justifyContent: 'center' }} />
                    </div>
                    {
                        articles != null && Array.isArray(articles) && articles.length > 0 ?
                            (
                                <div className={"MoreArticles"}>
                                    <HOne title={dictionary.more_articles} />
                                    <InnerArticleGrid
                                        dictionary={dictionary}
                                        data={articles}
                                        projectName={projectName}
                                        projectId={projectId}
                                    />
                                </div>
                            ) : null
                    }

                    {
                        filteredProjects != null && Array.isArray(filteredProjects) && filteredProjects > 0 ?
                            (
                                <div className={"SimilarProjects"}>
                                    <HOne title={`${dictionary.similar_projects_in} ${neighborhood.name}`} />
                                    <InnerArticleGrid
                                        dictionary={dictionary}
                                        data={filteredProjects}
                                        type={'card'}
                                        projectId={projectId}
                                        projectName={projectName}
                                    />
                                </div>
                            ) : null
                    }
                    
                    <Modal
                        ModalBlurStyle={{ backgroundColor: "rgba(0,0,0,0.85)" }}
                        closeModal={this.closeModal.bind(this, false)}
                        modalClass={'MessageModal'}
                        closeColor={'#000'}
                        speed={0.5}
                        ModalStyle={{ justifyContent: 'center', flexDirection: 'column', padding: "20px", alignItems: 'center' }}
                        isVisible={isVisibleMessage}>
                        <HOne addclass={"xsmall"} align={"center"} title={`${dictionary.request_about}`} line={"none"} />
                        <img src={data.project_logo === null ? null : `https://ngirealty.com${data.project_logo}`} className={"ProjectLogo"} alt=""></img>
                        <br />
                        {data.web_urgency ?
                            <React.Fragment>
                                <svg xmlns="http://www.w3.org/2000/svg" width="138.247" height="2" viewBox="0 0 138.247 2">
                                    <defs>
                                        <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
                                            <stop offset="0" stopColor="#a96903" />
                                            <stop offset="0.258" stopColor="#aa6a02" />
                                            <stop offset="0.352" stopColor="#b07102" />
                                            <stop offset="0.418" stopColor="#b97d02" />
                                            <stop offset="0.472" stopColor="#c78e01" />
                                            <stop offset="0.518" stopColor="#daa401" />
                                            <stop offset="0.557" stopColor="#f0be00" />
                                            <stop offset="0.579" stopColor="#ffd100" />
                                            <stop offset="1" stopColor="#a96903" />
                                        </linearGradient>
                                    </defs>
                                    <g id="Сгруппировать_94" data-name="Сгруппировать 94" transform="translate(-2822.173 274.933)">
                                        <rect id="Прямоугольник_18" data-name="Прямоугольник 18" width="138.247" height="2" transform="translate(2822.173 -274.933)" fill="url(#linear-gradient)" />
                                    </g>
                                </svg>
                                <br />
                                <div className={"FormText"}>
                                    {data.web_urgency}
                                </div>
                            </React.Fragment>
                            : (null)
                        }
                        <UserForm
                            className="MobileMessageModal"
                            thankModal={true}
                            inputBans={{ comment: true, message: true }}
                            clearForm={this.clearForm}
                            message={dictionary.thank_you_deal}
                            initialMessage={`${dictionary.send_me_more_details_about_project} ${data.name}`}
                            saveCurrentSelectedCountry={this.saveCurrentSelectedCountry}
                            country={country}
                            topPartRow={true}
                            contactForm={contactInfo}
                            handleInput={this.handleInput}
                            width={width}
                            secureInfo={true}
                            dictionary={dictionary}
                            style={{ textAlign: 'center', justifyContent: 'center' }}
                        />
                    </Modal>
                </div>
            )
        }
        return <div></div>;


    };
}

export default withRouter(ArticleInnerPage);